import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

export interface DurationOption {
  seconds: number;
  label: string;
}

@Component({
  selector: 'meeting-scheduler-duration-multi-select',
  templateUrl: './duration-multi-select.component.html',
  styleUrls: ['./duration-multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DurationMultiSelectComponent implements OnInit, OnDestroy {
  @Input() options: DurationOption[];
  @Input() title: string;
  @Input() hint: string;
  @Input() description: string;

  @Input() set duration(duration: number) {
    this._duration = duration;
    this.loading = typeof duration !== 'number';
    this.durationFormControl.setValue(duration, { emitEvent: false });
    this.cd.markForCheck();
  }

  @Output() durationSelected: EventEmitter<DurationOption> = new EventEmitter();

  loading: boolean;
  _duration: number;
  durationFormControl: UntypedFormControl;

  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly cd: ChangeDetectorRef,
  ) {
    this.durationFormControl = this.fb.control(this._duration);
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.durationFormControl.valueChanges.subscribe((durationSeconds) => {
        const optWithSameDuration = this.options.find((d) => d.seconds === durationSeconds);
        const option: DurationOption = { seconds: durationSeconds, label: optWithSameDuration?.label || '' };
        this.durationSelected.emit(option);
        this.cd.markForCheck();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
